import React, { useEffect } from "react";
import { EnvironmentConfig } from "../../shared/types/config.types";
import configAPI from "../../api/config.api";

const initialConfigContext: EnvironmentConfig | null = null;
const _ConfigContext = React.createContext(
  initialConfigContext as EnvironmentConfig | null
);

export const useConfig = () => {
  return React.useContext(_ConfigContext);
};

export const ConfigContext: React.FC = ({ children }) => {
  const [configState, setConfigState] =
    React.useState<EnvironmentConfig | null>(null);
  const [requestedConfigState, setRequestedConfigState] =
    React.useState<boolean>(false);

  useEffect(() => {
    if (!requestedConfigState) {
      configAPI.getConfig().then((res) => {
        setConfigState(res);
        setRequestedConfigState(true);
      });
    }
  }, [requestedConfigState]);

  return (
    <_ConfigContext.Provider value={configState}>
      {children}
    </_ConfigContext.Provider>
  );
};
